import { Module, MutationTree, ActionTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';

import _ from 'lodash';
import { ParametresUtilisateur, ParametresUtilisateurState } from './types';

const namespaced: boolean = true;

export const state: ParametresUtilisateurState = {
	parametres: new Map<string, ParametresUtilisateur>()
};

export const mutations: MutationTree<ParametresUtilisateurState> = {
	mutateParametresUtilisateur(state: ParametresUtilisateurState, parametres: ParametresUtilisateur): void {
		const rpps = _.get(parametres, 'numRpps');
		if (!_.isNil(rpps)) {
			state.parametres?.set(rpps, parametres);
		}
	}
};

export const actions: ActionTree<ParametresUtilisateurState, RootState> = {
	setParametresUtilisateur(state, parametres: ParametresUtilisateur): void {
		state.commit('mutateParametresUtilisateur', parametres);
	}
};

export const getters: GetterTree<ParametresUtilisateurState, RootState> = {
	getParametresUtilisateur(state): Map<string, ParametresUtilisateur> {
		return state.parametres;
	}
};

export const parametresUtilisateur: Module<ParametresUtilisateurState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
